export default __webpack_public_path__ + "static/media/home_.9bb42701.svg";